import { moneyFormatter } from "web_myplann/Shared/Utils/moneyFormatters";

type ExpenseAmounts = {
	monthlyPayment: number;
	sustainableAmount: number;
};

export const formatExpenseSubtitle = (
	expense: ExpenseAmounts,
	currencySign: string,
	minimumLabel: string,
) => {
	const amount = moneyFormatter(expense.monthlyPayment, currencySign);
	if (!expense.sustainableAmount) return amount;

	const minimum = moneyFormatter(expense.sustainableAmount, currencySign);
	return `${amount} (${minimumLabel} ${minimum})`;
};
